import { useState } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase.js';
import { useAuth } from '../auth/useAuth.js';
import Field from '../components/Field.jsx';
import ErrorBanner from '../components/ErrorBanner.jsx';

export function LoginPage() {
  const { authStatus } = useAuth();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (authStatus === 'signed-in') {
    return <Navigate to={location.state?.from ?? '/'} replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError(null);

    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });

    if (signInError) {
      // Supabase returns the same message for a wrong password and an unknown
      // address, which is correct — telling an attacker which addresses exist
      // is a gift. Keep it that way.
      setError(
        signInError.message === 'Invalid login credentials'
          ? 'That email address and password do not match. Check both and try again.'
          : signInError.message
      );
      setBusy(false);
      return;
    }
    // On success the auth listener flips authStatus and the redirect above fires.
  }

  return (
    <div className="centered-page">
      <form className="card" onSubmit={handleSubmit}>
        <h1>Sign in to Attest</h1>
        <p className="muted">For training staff — coordinators, instructors, and STOs.</p>

        <ErrorBanner error={error} />

        <Field
          label="Email address"
          type="email"
          value={email}
          onChange={setEmail}
          autoComplete="username"
          disabled={busy}
        />
        <Field
          label="Password"
          type="password"
          value={password}
          onChange={setPassword}
          autoComplete="current-password"
          disabled={busy}
        />

        <button type="submit" className="btn btn--primary" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="card__footer">
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
        <p className="card__footer muted">
          No account? Accounts are created by invitation — ask your training
          coordinator to invite you.
        </p>
      </form>
    </div>
  );
}

export default LoginPage;
